import React, { useState } from "react";
import SuperAdminNavbar from "../components/AdminSideComponents/layout/super-admin/SuperAdminNavbar";
import SuperAdminSidebar from "../components/AdminSideComponents/layout/super-admin/SuperAdminSidebar";
import { ADMIN_NAV_HEIGHT } from "../utils/constants";

const SuperAdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <React.Fragment>
      <div className="relative h-screen w-full overflow-hidden">
        {/* SIDEBAR */}
        <SuperAdminSidebar
          isOpen={isSidebarOpen}
          setIsOpen={setIsSidebarOpen}
        />

        {/* CONTENT AREA */}
        <div className="flex flex-col h-screen lg:ml-[14.5rem]">
          {/* NAVBAR */}
          <div className="fixed top-0 left-0 right-0 lg:ml-[14.5rem] z-20">
            <SuperAdminNavbar setIsSidebarOpen={setIsSidebarOpen} />
          </div>

          {/* SCROLLABLE MAIN */}
          <main
            style={{
              scrollbarGutter: "stable",
              marginTop: `${ADMIN_NAV_HEIGHT}px`,
            }}
            className="flex-1 overflow-y-auto bg-gray-100"
          >
            {children}
          </main>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SuperAdminLayout;
